/**************************************************
 * Nombre:       BarraBusqueda
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, InputAdornment, TextField} from "@mui/material";
import {useContext, useState} from "react";
import {contexData} from "../../../App";
import lupa from '../../../Recursos/lupa.svg'
import {useNavigate} from "react-router-dom";

const BarraBusqueda = () => {
    const cData = useContext(contexData)
    const navigate = useNavigate()
    const [palabra, setPalabra] = useState('')

    const enviarPalabra = () => {
        if (palabra) {
            navigate('/')
            cData.setIconoCat(lupa)
            cData.setSubCatEscogida(palabra)
        }
    }

    return (
        <TextField

            placeholder={'Buscar producto'}
            size={'small'}
            value={palabra}
            onChange={(e) => setPalabra(e.target.value)}
            variant={'outlined'}
            sx={{backgroundColor: '#fff', borderRadius: 2, py: 0, marginTop: 0, px: 0}}
            slotProps={{
                input: {
                    endAdornment: (
                        <InputAdornment position="end">
                            <Button
                                onClick={() => enviarPalabra()}
                                sx={{py: 0, backgroundColor: '#7E8BFF'}}>Buscar</Button>
                        </InputAdornment>
                    ),
                    disableUnderline: true,
                    sx: {
                        backgroundColor: '#fff',
                        fontSize: 16,
                        marginTop: 0,
                        px: 1
                    }
                },
                inputLabel: {
                    sx: {
                        // marginBottom: -10
                    }
                }
            }
            }

        />
    )

}
export default BarraBusqueda